import h, { useRef as x, useEffect as f } from "react";
const y = {
  sandbox: "https://sdk.sandbox.connect.xyz/auth-web/index.js",
  production: "https://sdk.connect.xyz/auth-web/index.js"
}, I = "connect-auth-script", a = "connect-auth", R = (r = "production") => y[r], E = ({
  jwt: r,
  env: c = "production",
  theme: l,
  onError: n,
  onClose: o,
  onDeposit: s,
  onEvent: i,
  onLoaded: u,
  ...m
}) => {
  const d = x(null);
  return f(() => {
    const t = d.current;
    t && (n && (t.onError = n), o && (t.onClose = o), s && (t.onDeposit = s), i && (t.onEvent = i), u && (t.onLoaded = u));
  }, [n, o, s, i, u]), f(() => {
    const t = R(c), p = `${I}-${c}`;
    if (document.getElementById(p))
      return;
    const e = document.createElement("script");
    e.id = p, e.src = t, e.type = "module", e.async = !0, e.onerror = () => {
      console.error(`Failed to load the script for ${a} from ${c} environment.`);
    }, document.head.appendChild(e);
  }, [c]), h.createElement(a, {
    ref: d,
    jwt: r,
    env: c,
    theme: l,
    ...m
  });
};
export {
  E as Auth
};
